'use strict';

document.addEventListener('DOMContentLoaded', () => {
	const tabRoots = document.querySelectorAll('.js-tab');

	tabRoots.forEach((tabRoot) => {
		const tabButtons = Array.from(tabRoot.querySelectorAll('[data-tab-trigger]'));
		const tabPanels = Array.from(tabRoot.querySelectorAll('[data-tab-panel]'));

		if (tabButtons.length === 0 || tabPanels.length === 0) {
			return;
		}

		const activateTab = (tabName) => {
			tabButtons.forEach((tabButton) => {
				const isActive = tabButton.dataset.tabTrigger === tabName;
				tabButton.classList.toggle('is-active', isActive);
				tabButton.setAttribute('aria-selected', String(isActive));
				tabButton.setAttribute('tabindex', isActive ? '0' : '-1');
			});

			tabPanels.forEach((tabPanel) => {
				const isActive = tabPanel.dataset.tabPanel === tabName;
				tabPanel.classList.toggle('is-active', isActive);
				tabPanel.hidden = !isActive;
			});
		};

		const moveFocus = (currentIndex, move) => {
			const nextIndex = (currentIndex + move + tabButtons.length) % tabButtons.length;
			tabButtons[nextIndex].focus();
			activateTab(tabButtons[nextIndex].dataset.tabTrigger);
		};

		tabButtons.forEach((tabButton, index) => {
			tabButton.addEventListener('click', () => {
				activateTab(tabButton.dataset.tabTrigger);
			});

			tabButton.addEventListener('keydown', (event) => {
				if (event.key === 'ArrowRight') {
					event.preventDefault();
					moveFocus(index, 1);
				}
				if (event.key === 'ArrowLeft') {
					event.preventDefault();
					moveFocus(index, -1);
				}
				if (event.key === 'Home') {
					event.preventDefault();
					tabButtons[0].focus();
					activateTab(tabButtons[0].dataset.tabTrigger);
				}
				if (event.key === 'End') {
					event.preventDefault();
					tabButtons[tabButtons.length - 1].focus();
					activateTab(tabButtons[tabButtons.length - 1].dataset.tabTrigger);
				}
			});
		});

		const initialButton =
			tabButtons.find((tabButton) => tabButton.classList.contains('is-active')) ||
			tabButtons[0];
		activateTab(initialButton.dataset.tabTrigger);
	});
});
